import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useLanguage } from "../../i18n/LanguageContext";

function AboutCard() {
  const { t } = useLanguage();
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {t("aboutcard.intro")}
          </p>
          <ul>
            {t("aboutcard.items").map((item, i) => (
              <li className="about-activity" key={i}>
                <ImPointRight /> {item}
              </li>
            ))}
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "{t("aboutcard.quote")}"
          </p>
          <footer className="blockquote-footer">Breiner</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;